export default {
    namespaced: true,
    state: {
        client_id: 0,
        client_name: '',
        user_name: '',
        loginuser_id: 0,
        email: '',
        link_company_limit: 0
    },
    mutations: {
        // ユーザー基本情報をセット
        setUserBasicInformation(state, admin_basic_information) {
            state.client_id = admin_basic_information.hasOwnProperty('client_id')
                ? admin_basic_information.client_id
                : 0;
            state.client_name = admin_basic_information.hasOwnProperty('client_name')
                ? admin_basic_information.client_name
                : 0;
            state.user_name = admin_basic_information.hasOwnProperty('user_name')
                ? admin_basic_information.user_name
                : 0;
            state.loginuser_id = admin_basic_information.hasOwnProperty('loginuser_id')
                ? admin_basic_information.loginuser_id
                : 0;
            state.email = admin_basic_information.hasOwnProperty('email') ? admin_basic_information.email : '';
            state.link_company_limit = admin_basic_information.hasOwnProperty('link_company_limit')
                ? admin_basic_information.link_company_limit
                : 0;
        }
    },
    actions: {},
    getters: {
        // クライアントIDを取得
        getClientId(state) {
            return state.client_id;
        },
        // クライアント名を取得
        getClientName(state) {
            return state.client_name;
        },
        // ユーザー名を取得
        getUserName(state) {
            return state.user_name;
        },
        // ユーザーIDを取得
        getLoginuserId(state) {
            return state.loginuser_id;
        },
        // メールアドレスを取得
        getEmail(state) {
            return state.email;
        },
        // 企業属性付与の上限数を取得
        getLinkCompanyLimit(state) {
            return state.link_company_limit;
        }
    }
};
